import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=bee8170e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee8170e')) {
      api.createRecord('bee8170e', component.options)
    } else {
      api.reload('bee8170e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=bee8170e&", function () {
      api.rerender('bee8170e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/comp/FavElement.vue"
export default component.exports